import { render } from "./BuybackReception.vue?vue&type=template&id=2ad7a3a1&scoped=true&ts=true&lang=pug"
import script from "./BuybackReception.vue?vue&type=script&lang=ts"
export * from "./BuybackReception.vue?vue&type=script&lang=ts"

import "./BuybackReception.vue?vue&type=style&index=0&id=2ad7a3a1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad7a3a1"]])

export default __exports__